<template>
  <div id="user-info-layer">
    <div class="user-info">
      <div class="info-title">账号信息</div>
      <div class="base-info">
        <div class="base-item clearfix">
          <p class="base-title">账户名称</p>
          <p class="base-content">{{ userInfo.account }}</p>
          <!-- <el-input ref="userName" v-show="isEdit" class="base-input" v-model="userName" placeholder="请输入账户名"></el-input> -->
          <!-- <a
            href="javascript:;"
            type="primary"
            @click="showEditHandle"
            class="base-edit"
            >修改</a
          > -->
          <!-- <a class="base-edit" href="javascript:;" @click="showEditHandle">{{editName}}</a> -->
          <el-button type="text" class="base-edit" icon="el-icon-edit" @click="resetUserNameHandle">修改</el-button>
        </div>
        <div class="base-item clearfix">
          <p class="base-title">已绑定手机号</p>
          <p class="base-content">{{ phone }}</p>
          <!-- <a href="javascript:;" class="add-item" v-show="!userInfo.phone"
            >绑定手机号</a
          >
          <a
            href="javascript:;"
            type="primary"
            v-show="userInfo.phone"
            @click="showPhoneEditHandle"
            class="base-edit"
            >修改</a
          > -->
          <el-button type="text" class="base-edit" icon="el-icon-edit" @click="resetPhoneHandle">修改</el-button>
        </div>
        <!-- <div class="base-item clearfix">
          <p class="base-title">已绑定邮箱</p>
          <p class="base-content">{{ userInfo.email }}</p>
          <router-link
            to="/bind-email"
            class="add-item"
            v-show="!userInfo.email"
            >绑定邮箱</router-link
          >
        </div> -->
        <div class="base-item clearfix">
          <p class="base-title">账户密码</p>
          <p class="base-content">{{ '*****' }}</p>
          <el-button type="text" class="base-edit" icon="el-icon-edit" @click="resetHandle">修改</el-button>
        </div>
        <div class="base-item clearfix">
          <p class="base-title">签署密码</p>
          <p class="base-content">{{ '*****' }}</p>
          <el-button type="text" class="base-edit" icon="el-icon-edit" @click="resetPINHandle">修改</el-button>
        </div>
        <!-- <div class="base-item clearfix">
          <p class="base-title">Ukey登录</p>
          <p class="base-content">{{ userInfo.key }}</p>
          <a
            class="add-item"
            v-show="!userInfo.key"
            @click="bindKey"
            href="javascript:;"
            >绑定Ukey</a
          >
          <a
            class="add-item"
            v-show="userInfo.key"
            @click="untieKey"
            href="javascript:;"
            >解绑Ukey</a
          >
        </div> -->
      </div>

      <div class="info-title" v-if="idCard" style="margin-top: 27px">
        个人信息
      </div>
      <div class="person-info" v-if="idCard">
        <div class="base-item clearfix">
          <p class="base-title">姓名</p>
          <p class="base-content">{{ userInfo.name }}</p>
          <router-link to="/personal-auth-info" v-show="!userInfo.name" class="add-item">去认证</router-link>
        </div>
        <div class="base-item clearfix">
          <p class="base-title">身份证</p>
          <p class="base-content">{{ idCard }}</p>
          <!-- <a href="javascript:;" class="add-item">绑定邮箱</a> -->
        </div>
        <!-- <div class="base-item clearfix">
          <p class="base-title">个人证书</p>
          <p class="base-content">158XXXX8208@qq.com</p>
          <a href="javascript:;" class="add-item">查看</a>
        </div> -->
      </div>
    </div>

    <!-- <div class="company-info" v-if="companyList.length > 0">
      <div class="company-list clearfix">
        <div
          class="company-list-layer clearfix"
          ref="companyNav"
          id="companyNav"
        >
          <a
            href="javascript:;"
            :class="{ active: company.companyId == curCompany.companyId }"
            @click="changeCompany(company.companyId)"
            v-for="company in companys"
            :key="company.companyId"
            v-if="company.userCompanyStatus == '0' && company.isAuthed == '1'"
            >{{ company.companyName }}</a
          >
        </div>
      </div>
      <div
        class="company-content"
        v-show="
          curCompany.userCompanyStatus == '0' && curCompany.isAuthed == '1'
        "
      >
        <p class="company-name">{{ curCompany.companyName }}</p>
        <div class="company-box">
          <div class="base-item clearfix">
            <p class="base-title">企业证件号</p>
            <p class="base-content">{{ curCompany.creditCode }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">管理员联系方式</p>
            <p class="base-content">{{ curCompany.adminPhone }}</p>
            <p class="base-content">{{ curCompany.adminEmail }}</p>
          </div>
          <div class="base-item clearfix" style="padding-bottom: 50px">
            <p class="base-title">企业</p>
            <p class="base-content">
              <span v-if="curCompany.isAuthed == '0'">认证中</span>
              <span v-if="curCompany.isAuthed == '1'">已认证 </span>
              <span v-if="curCompany.isAuthed == '2'">认证失败 </span>
              <span v-if="curCompany.isAuthed == '3'">未认证</span>
            </p>
          </div>
        </div>
      </div>
    </div> -->

    <reset-password ref="rpassword"></reset-password>
    <reset-username ref="rusername"></reset-username>

    <reset-verify-phone ref="rverifyphone"></reset-verify-phone>
    <pin ref="pin"></pin>
  </div>
</template>
<script>
import resetPassword from "./reset-password";
import resetUsername from "./reset-username";

import resetVerifyPhone from "./reset-verify-phone";
import pin from "./reset-pin";
import { mapState } from "vuex";
import { getRandomApi, untieKey, bindKey, getInfoApi } from "@/api/common";
// import {userInfo} from "os";

export default {
  components: {
    resetPassword,
    resetUsername,
    resetVerifyPhone,
    pin,
  },
  data() {
    return {
      isEdit: false,
      curCompany: {},
      userName: "",
      editName: "修改",
      companys: [],
      random: "",
      randomId: "",
      sign: "",
    };
  },
  created() {
    // if (this.companyList) {
    //   this.companyList.forEach((company) => {
    //     this.companys.push({
    //       companyId: company.companyId,
    //       creditCode: company.creditCode
    //         ? company.creditCode.replace(/(\w{1})(\w+)(\w{1})/, function(
    //             x,
    //             y,
    //             z,
    //             p
    //           ) {
    //             var i = "";
    //             while (i.length < z.length) {
    //               i += "*";
    //             }
    //             return y + i + p;
    //           })
    //         : "",
    //       userCompanyStatus: company.userCompanyStatus,
    //       companyName: company.companyName,
    //       adminName: company.adminName,
    //       adminPhone: company.adminPhone.replace(
    //         /(\w{3})(\w+)(\w{4})/,
    //         function(x, y, z, p) {
    //           var i = "";
    //           while (i.length < z.length) {
    //             i += "*";
    //           }
    //           return y + i + p;
    //         }
    //       ),
    //       isAuthed: company.isAuthed,
    //       adminEmail: company.adminEmail,
    //     });
    //   });
    //   this.curCompany = this.companys[0];
    // }
  },
  mounted() {
    this.$nextTick(() => {
      if (document.querySelector("#companyNav")) {
        if (document.querySelector("#companyNav").children.length > 0) {
          document.querySelector("#companyNav").style.width =
            document.querySelector("#companyNav").children.length *
            document.querySelector("#companyNav").children[0].offsetWidth +
            17 * document.querySelector("#companyNav").children.length +
            "px";
        }
      }
    });
  },
  methods: {
    // changeCompany(companyId) {
    //   this.companys.forEach((company) => {
    //     if (company.companyId == companyId) {
    //       this.curCompany = company;
    //     }
    //   });
    // },
    showEditHandle() {
      this.$refs.rusername.dialogVisible = true;
    },
    showPhoneEditHandle() {
      this.$refs.phone.resetForm.oldPhone = this.userInfo.phone;
      this.$refs.phone.showOldPhone = this.phone;
      this.$refs.phone.dialogVisible = true;
    },
    resetPINHandle() {
      this.$refs.pin.resetForm.phone = this.userInfo.phone;
      this.$refs.pin.showOldPhone = this.phone;
      this.$refs.pin.dialogVisible = true;
    },
    // bindKey() {
    //   getRandomApi()
    //     .then((res) => {
    //       console.log(res);
    //       if (res.code != 200) {
    //         this.$message({
    //           showClose: true,
    //           message: res.message,
    //           type: "warning",
    //         });
    //       } else {
    //         this.random = res.random;
    //         this.randomId = res.id;
    //         this.detachSignHandle(this.random);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // untieKey() {
    //   untieKey().then((res) => {
    //     if (res.code !== 0) {
    //       this.$message({
    //         showClose: true,
    //         message: res.message,
    //         type: "warning",
    //       });
    //     } else {
    //       this.$message({
    //         message: res.message,
    //         type: "success",
    //       });
    //       this.getInfoHandle();
    //     }
    //   });
    // },
    getInfoHandle() {
      // getInfoApi().then((res) => {
      //   console.log(res);
      //   if (res.code !== "0") {
      //     this.$message({
      //       showClose: true,
      //       message: res.message,
      //       type: "warning",
      //     });
      //   } else {
      //     this.$store.commit("SET_USER_INFO", res.data); // 保存用户信息
      //     // if (this.$store.state.userInfo.isFirstLogin) {
      //     //   this.$router.push({
      //     //     path: '/perfect-info'
      //     //   })
      //     // }
      //   }
      // });
    },
    detachSignHandle(random) {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        // ie
        this.detachSignIe(random);
      } else {
        // 非ie
        this.detachSign(random);
      }
      console.log(this.sign);
      this.requestBindKey();
    },
    requestBindKey() {
      console.log(this.userInfo);
      bindKey({
        id: this.randomId,
        sign: this.sign,
      }).then((res) => {
        if (res.code !== 0) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.getInfoHandle();
        }
      });
    },
    resetUserNameHandle() {
      this.$refs.rusername.dialogVisible = true;
      this.$refs.rusername.resetForm.userName = "";
      this.$refs.rusername.resetForm.smgcode = "";
    },
    resetHandle() {
      this.$refs.rpassword.dialogVisible = true;
      this.$refs.rpassword.resetForm.pass = "";
      this.$refs.rpassword.resetForm.smgcode = "";
    },
    resetPhoneHandle() {

      this.$refs.rverifyphone.dialogVisible = true;
      this.$refs.rverifyphone.resetForm.smgcode = "";

      // this.$refs.phone.dialogVisible = true;
      // this.$refs.phone.resetForm.pass = "";
      // this.$refs.phone.resetForm.smgcode = "";
    },
  },
  computed: {
    idCard() {
      var str1 = "";
      if (this.userInfo.idCard) {
        str1 = this.userInfo.idCard.replace(/(\d{1})(\d+)(\d{1})/, function (
          x,
          y,
          z,
          p
        ) {
          var i = "";
          while (i.length < z.length) {
            i += "*";
          }
          return y + i + p;
        });
        return str1;
      }
    },
    phone() {
      var str1 = "";
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(/(\d{3})(\d+)(\d{4})/, function (
          x,
          y,
          z,
          p
        ) {
          var i = "";
          while (i.length < z.length) {
            i += "*";
          }
          return y + i + p;
        });
        return str1;
      }
    },
    ...mapState(["userInfo", "userContractInfo", "companyList"]),
  },
};
</script>
<style>
#user-info-layer .base-input input {
  height: 36px;
}
</style>
<style scoped>
.base-info {
  margin-top: 20px;
  margin-left: 20px;
}

.base-item {
  position: relative;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  margin-top: 15px;
}

.base-title {
  float: left;
  width: 100px;
  color: #4E5969;
}

.base-content {
  float: left;
  margin-left: 50px;
  color: #1D2129;
}

.base-input {
  position: absolute;
  left: 150px;
  top: 0;
  width: 150px;
  height: 36px;
}

.base-edit {
  /* width: 67px;
  height: 26px; */
  /* position: absolute;
  left: 350px;
  top: 0px; */
  /* background: #3296FA;
  border-radius: 10px;
  display: block;
  color: white;
  font-size: 13px;
  text-align: center;
  line-height: 26px;
  padding: 0; */
  padding: 0;
  margin-left: 20px;
}

.add-item {
  position: absolute;
  left: 520px;
  top: 0;
  color: #1b96ff;
}

.person-info {
  margin: 36px 0 0 46px;
}

.company-info {
  /* width: 942px; */
  margin-top: 20px;
}

.company-list {
  width: 100%;
  height: 54px;
  overflow-x: auto;
  overflow-y: hidden;
}

.company-list a {
  display: block;
  width: 175px;
  height: 43px;
  text-align: center;
  overflow: hidden;
  font-size: 16px;
  color: #333333;
  background: #e5e5e5;
  line-height: 43px;
  float: left;
  margin-right: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-list a:last-child {
  margin-right: 0;
}

.company-list a.active {
  background: #ffffff;
}

.company-content {
  /* width: 942px; */
  min-height: calc(100vh - 587px);
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}

.company-name {
  font-size: 16px;
  color: #333333;
  width: 855px;
  margin: 27px auto 0;
  padding-bottom: 17px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 18px;
}

.company-box {
  margin: 15px 0 0 43px;
}

.company-box .base-title {
  width: 112px;
}

.company-box .base-content {
  margin-left: 43px;
  margin-right: 20px;
}

.company-box .add-item {
  left: 433px;
}

.el-button [class*="el-icon-"]+span {
  margin-left: 4px;
}
</style>
<style lang="scss" scoped>
.info-title {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  border-bottom: 1px solid #F2F3F5;
  padding-left: 22px;
}
</style>
